export function throwOnUnset<T>(value: T | null | undefined, exceptionMessage: string): T {
  if (value === undefined || value === null) {
    throw Error(exceptionMessage);
  }

  return value;
}
